import { Directive, ElementRef, inject, output } from '@angular/core';

@Directive({
  selector: '[uiClickOutside]',
  host: {
    '(document:click)': 'onDocumentClick($event)',
  },
})
export class ClickOutsideDirective {
  private elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
  clickOutside = output<MouseEvent>();

  onDocumentClick(event: MouseEvent) {
    const target = event.target as Node;
    if (target && !this.elementRef.nativeElement.contains(target)) {
      this.clickOutside.emit(event);
    }
  }
}
